require("../vendor/gridstack.all.js");
//require("../vendor/gridstack.min.css");
export { GridStackModule } from './gridstack.module';
//# sourceMappingURL=index.js.map